import type { BlockCMS, Product } from '@/types'
import { Autoplay, FreeMode, Grid, Navigation } from 'swiper/modules'
import { Swiper, SwiperSlide } from 'swiper/react'
import ProductCard from '../ProductCard'

interface ModuleProductListType {
  data: BlockCMS
}
const ModuleProductList = ({ data }: ModuleProductListType) => {

  return (
    <section
      id={data._id}
      className={`${data?.type} ${
        data?.hideBot ? '' : 'pb-3'
      } px-2 scroll-mt-[150px]`}
    >
      <div className='rounded-lg bg-white py-2 mt-2'>
       
        <div className='flash-sale--content'>
          {data?.data?.length >= 4 ? (
            <Swiper
              modules={[Grid, FreeMode, Autoplay, Navigation]}
              className='flashSaleSwp'
              slidesPerView={2}
              grid={{
                rows: 2,
                fill: 'row',
              }}
              slidesPerGroup={2}
              freeMode={true}
              spaceBetween={8}
              autoplay={false}
              speed={400}
              navigation={true}
            >
              {data?.data?.map((product: Product, idx: number) => (
                <SwiperSlide key={product._id + idx + 'fs'}>
                  <ProductCard
                    product={product}
                    type='cms'
                    layout={2}
                    className='flashSaleSlider'
                  />
                </SwiperSlide>
              ))}
            </Swiper>
          ) : (
            <div className='max-w-screen grid grid-cols-2 gap-2 px-2'>
              {data?.data?.map((product: Product, idx: number) => (
                <ProductCard
                  key={product._id + idx + 'fs'}
                  product={product}
                  type='cms'
                  layout={2}
                  className=''
                />
              ))}
            </div>
          )}
          
        </div>
      </div>
    </section>
  )
}

export default ModuleProductList
